import React from 'react';
import './Error.css';
import Header from '../Components/Layout/Header';
import Footer from '../Components/Layout/Footer';
import Button from '../Components/Comman/Button';

const Error = (props) => {
  return (
    <>
      <Header/>
      <main>
        <div className='section1_error'>
          <div className='section1_error_div1'>
            <div className='section1_error_div2'>
              <h1 className='section1_error_text1'>404</h1>
              <h2 className='section1_error_text2'>Page Not Found</h2>
              <h2 className='section1_error_text2'>The page you're looking for can't be found</h2>
            </div>
            <Button text="Explore more" href="/" />
          </div>
        </div>
      </main>
      <Footer/>
    </>
  );
};

export default Error;